var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGibraltar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 24,
    viewBox: "0 0 30 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M30 24H0V0h30z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#c92a1e",
    d: "M30 24H0v-8h30z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f3da4a",
    d: "m15.97 17.03-.97-.56-.97.56h-.21v.37h.21l.77.45V20h-1.17v.61h.41v-.27h.4v.27h.36v.14h-.37v.27h-.39v-.27h-.4v.6h1.16v.35h.4v-3.87l.77-.44h.21v-.37zm-.32.19-.65.37-.65-.37.65-.38z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M10.21 11.12h5.16v3.55H10.2zm.64-4.53h1.5v2.73h-1.5z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14.63 11.12h5.16v3.55h-5.16zm3.03-4.54h1.49v2.74h-1.5zm-3.88-1.74h2.36v4.3h-2.36z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#c92a1e",
    d: "M20.61 9.68V9.3H21v-.9h-.47v.46h-.57V8.4h-.47V5.63h.18v-.39h.3v-.81h-.61v.37h-.45v-.37h-.88v.37h-.45v-.37h-.52v.81h.17v.39h.16v2.76h-.08v.46h-.65V8.4h-.23V4.88h.25v-.51H17v-.68h-.57v.33h-.47V3.7h-.72v.33h-.47V3.7h-.71v.33h-.47V3.7H13v.68h.31v.51h.26V8.4h-.23v.46h-.65V8.4h-.08V5.63h.15v-.39h.17v-.81h-.51v.37h-.45v-.37h-.88v.37h-.45v-.37h-.62v.81h.3v.39h.18v2.76h-.47v.46h-.57V8.4H9v.92h.38v.37h.32v4.45l-.67.44H9v.57h2.96v.23h6.08v-.23h2.95v-.57h-.03l-.67-.44V9.68zm-6.2-4.15v.82h-.15v-.82zm1.18.82v-.82h.15v.82zm-.67.09V5.29h.15v1.15zm-.52 1.95V7.37c0-.43.38-.55.6-.55s.6.12.6.55v1.49h-1.2zm1.72 5.96h-2.25v-1.6c0-.69.42-1.1 1.13-1.1.83 0 1.12.57 1.12 1.1zm1.81-6.7c0-.28.23-.5.51-.5h.03c.26 0 .45.23.45.5v1.2h-.98v-1.2m-6.86.74v-.74c0-.27.2-.5.46-.5h.03c.28 0 .5.22.5.5v1.2h-.99zm-.28 4.57c0-.44.36-.8.78-.8a.8.8 0 0 1 .79.8v1.15H10.8zm8.42 1.15h-1.57v-1.15c0-.45.35-.8.79-.8a.8.8 0 0 1 .78.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGibraltar);
export default __webpack_public_path__ + "static/media/gibraltar.34f5fe8673a11c13d819a62d80874bbb.svg";
export { ForwardRef as ReactComponent };